<template>
  <section class="nx-hero" id="home">
    <div class="nx-hero-container">
      <div class="nx-hero-bg">
        <div class="nx-hero-particles"></div>
      </div>
      <el-carousel
        :autoplay="true"
        :interval="interval"
        arrow="never"
        :height="carouselHeight"
        class="nx-hero-carousel"
        indicator-position
      >
        <el-carousel-item v-for="(item, index) in items" :key="index">
          <div class="nx-hero-slide">
            <img :src="item.image" class="nx-hero-image" />
            <div class="nx-hero-overlay"></div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NxHero',
  props: {
    items: {
      type: Array,
      required: true
    },
    interval: {
      type: Number,
      default: 5000
    }
  },
  data() {
    return {
      carouselHeight: '725px'
    };
  },
  mounted() {
    this.updateCarouselHeight();
    window.addEventListener('resize', this.updateCarouselHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCarouselHeight);
  },
  methods: {
    updateCarouselHeight() {
      // 根据屏幕宽度调整轮播图高度
      if (window.innerWidth <= 768) {
        // this.carouselHeight = '400px';
        this.carouselHeight = '300px';
      } else if (window.innerWidth <= 1200) {
        this.carouselHeight = '500px';
      } else {
        this.carouselHeight = '725px';
      }
    }
  }
};
</script>

<style scoped>
.nx-hero {
  position: relative;
  /* padding: 60px 30px 40px; */
  padding: 90px 0px 0px;
  background: linear-gradient(180deg, #fafbfc 0%, #f5f7fa 50%, #f8f9fa 100%);
  overflow: hidden;
}

.nx-hero-container {
  /* max-width: 1400px; */
  width: 100vw;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  /* border-radius: 24px; */
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(21, 101, 192, 0.15);
  will-change: transform;
}

.nx-hero-bg {
  position: absolute;
  inset: 0;
  z-index: 1;
  background:
    radial-gradient(ellipse at 20% 20%, rgba(59, 130, 246, 0.06) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 80%, rgba(139, 92, 246, 0.05) 0%, transparent 50%);
}

.nx-hero-particles {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(2px 2px at 20px 30px, rgba(21, 101, 192, 0.5), transparent),
    radial-gradient(2px 2px at 40px 70px, rgba(0, 188, 212, 0.4), transparent),
    radial-gradient(2px 2px at 50px 50px, rgba(66, 165, 245, 0.4), transparent),
    radial-gradient(1px 1px at 80px 20px, rgba(21, 101, 192, 0.4), transparent),
    radial-gradient(2px 2px at 100px 80px, rgba(0, 188, 212, 0.35), transparent);
  background-repeat: repeat;
  background-size: 150px 150px;
  opacity: 0.5;
}

.nx-hero-slide {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .el-carousel__item {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.nx-hero-image {
  width: 100%;
  height: 100%;
  object-fit: fill;
  object-position: center;
  display: block;
  filter: drop-shadow(0 0 30px rgba(25, 118, 210, 0.2));
}

.nx-hero-carousel {
  /* border-radius: 24px; */
  overflow: hidden;
}

.nx-hero-overlay {
  display: none;
}

.nx-hero-content {
  position: relative;
  z-index: 10;
  text-align: left;
  padding: 250px 100px 80px 150px;
  animation: fadeInUp 1s ease-out;
}

.nx-hero-title {
  font-size: clamp(42px, 6vw, 64px);
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 15px;
  color: #ffffff;
  letter-spacing: 0.02em;
  text-shadow:
    0 2px 20px rgba(0, 0, 0, 0.5),
    0 0 40px rgba(25, 118, 210, 0.3);
}

.nx-hero-subtitle {
  font-size: clamp(16px, 2vw, 22px);
  font-weight: 400;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: 0.15em;
  text-transform: uppercase;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

/* 覆盖 Element UI 样式 - 浅色主题版 */
::v-deep .el-carousel__arrow {
  width: 65px;
  height: 65px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border: 2px solid rgba(21, 101, 192, 0.3);
  border-radius: 50%;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow: 0 6px 25px rgba(21, 101, 192, 0.2);
  will-change: transform, box-shadow;
}

::v-deep .el-carousel__arrow:hover {
  background: linear-gradient(135deg, rgba(21, 101, 192, 0.95) 0%, rgba(66, 165, 245, 0.9) 100%);
  border-color: var(--nx-blue-light);
  transform: scale(1.15);
  box-shadow: 0 10px 35px rgba(21, 101, 192, 0.35);
}

::v-deep .el-carousel__arrow i {
  color: var(--nx-blue-primary);
  font-size: 22px;
  font-weight: bold;
  text-shadow: none;
  transition: color 0.3s ease;
}

::v-deep .el-carousel__arrow:hover i {
  color: #ffffff;
}

::v-deep .el-carousel__indicators {
    position: absolute;
    bottom: 30px;
}

::v-deep .el-carousel__indicators {
  .el-carousel__indicator .el-carousel__button {
    /* width: 12px; */
    height: 12px;
    transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  }

  .el-carousel__indicator:hover .el-carousel__button {
    opacity: 1;
    transform: scale(1.15);
  }

  .el-carousel__indicator.is-active .el-carousel__button {
    /* width: 48px; */
    height: 12px;
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .nx-hero {
    /*padding: 40px 20px 30px; */
  }

  .nx-hero-container {
   /* border-radius: 16px; */
  }

  .nx-hero-carousel {
  /* border-radius: 16px; */
  }

  ::v-deep .el-carousel__arrow {
    width: 48px;
    height: 48px;
  }

  ::v-deep .el-carousel__arrow i {
    font-size: 18px;
  }

  ::v-deep .el-carousel__indicators {
    bottom: 8%;
  }
}
</style>
